import {
  Box,
  Input,
  List,
  ListItem,
  VStack,
} from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import { useStores } from "../../store/store_context";
import { useEffect, useState } from "react";

const SelectAccountNumber = observer(() => {
  const { pageStore } = useStores();
  const [showDropdown, setShowDropdown] = useState(false);

  useEffect(() => {
    pageStore.updateSelectedAccountNumber("");
  }, []);

  const filteredNumbers = pageStore.all_account_numbers.filter((item) =>
    item?.Num?.toLowerCase().includes(pageStore.selected_one_account_number.toLowerCase())
  );

  const handleSelect = (value) => {
    pageStore.updateSelectedAccountNumber(value);
    setShowDropdown(false);
  };

  return (
    <VStack align="start" position="relative" width="170px">
      <Input
        placeholder="Номер счета"
        value={pageStore.selected_one_account_number}
        onChange={(e) => {
          pageStore.updateSelectedAccountNumber(e.target.value);
          setShowDropdown(true);
        }}
        onFocus={() => setShowDropdown(true)}
        onBlur={() => setTimeout(() => setShowDropdown(false), 150)}
        bg="#333"
        color="#EEEEEE"
        borderRadius="10px"
        fontWeight="600"
        fontSize="14px"
      />

      {showDropdown && filteredNumbers.length > 0 && (
        <Box
          position="absolute"
          top="100%"
          width="200px"
          zIndex="1000"
          bg="#1A1A1A"
          borderRadius="md"
          boxShadow="md"
          maxHeight="200px"
          overflowY="auto"
        >
          <List spacing={1}>
            {filteredNumbers.map((item, index) => (
              <ListItem
                key={index}
                px={3}
                py={2}
                _hover={{ bg: "#2D2D2D", cursor: "pointer" }}
                color="#EEEEEE"
                onClick={() => handleSelect(item?.Num)}
              >
                {item?.Num}
              </ListItem>
            ))}
          </List>
        </Box>
      )}
    </VStack>
  );
});

export default SelectAccountNumber;
